import Kuangkuang from '@/components/kuangkuang/index.vue'
import Page from '@/components/page/index.vue'

export default Vue => {
 // 语法：Vue.component(后期调用的组件名, 单文件组件)
 // 注册：后期就可以直接调用，不需要单独导入
 // Vue.component('qfui-kuangkuang', Kuangkuang)
 // Vue.component('qfui-page', Page)
 // Vue.component(Kuangkuang.name, Kuangkuang)
 // Vue.component(Page.name, Page)

 const coms = [Kuangkuang, Page]
 coms.forEach(com => {
   Vue.component(com.name, com)
 })
}